import BaseData from './BaseData';
import {useSelector} from 'react-redux';
import {Selector} from '../../state/selector';
import BaseDataOverview from './BaseDataOverview';

const BaseDataPage = () => {
    const hasNormalCompanyAccess = useSelector(Selector.User.hasNormalCompanyAccess);
    const hasTesterCompanyAccess = useSelector(Selector.User.hasTesterCompanyAccess);
    const isEditor = useSelector(Selector.User.isEditor);

    if (hasNormalCompanyAccess) {
        return <BaseData />;
    } else if (hasTesterCompanyAccess) {
        return <BaseDataOverview />;
    } else if (isEditor) {
        // Editors get read-only Stammdaten access (BaseData handles read-only mode).
        return <BaseData />;
    } else {
        return null;
    }
};

export default BaseDataPage;
